import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrentSearchParams } from '../../../../decorators/current-search-params.decorator';
import { Chain } from '../../../../domains/chain';
import { CountryWithChild } from '../../../../domains/country-with-child';
import { Restaurant } from '../../../../domains/restaurant';
import { SearchFiltersPosition } from '../../../../models/enums/search-filters-position';
import { SearchParams } from '../../../../models/search-params';
import { SearchResult } from '../../../../models/search-result';
import { TypeCategorySection } from '../../../../models/type-category-section';
import { UnsplashImage } from '../../../../models/unsplash-image';
import { SearchFiltersPositionWrapper } from '../../../../models/wrappers/search-filters-position.wrapper';
import { ChainService } from '../../../../services/chain.service';
import { UnsplashService } from '../../../../services/unsplash.service';

@Component({
  selector: 'app-divider-mobile-modal',
  templateUrl: './divider-mobile-modal.component.html',
  styleUrls: ['./divider-mobile-modal.component.scss']
})
export class DividerMobileModalComponent implements OnInit {
  @Input() typeCategorySection: TypeCategorySection;
  @Input() cityName: string;
  @Input() searchResult: SearchResult;
  @Input() country: CountryWithChild;

  @Output() onRestaurantClicked = new EventEmitter<Restaurant>();
  @Output() onSearchClicked = new EventEmitter<boolean>();

  @CurrentSearchParams() searchParams: SearchParams;

  chains: Chain[] = [];
  delayed = false;
  backgroundImage: UnsplashImage;
  searchFiltersPosition= new SearchFiltersPositionWrapper(SearchFiltersPosition.AS_TITLE);

  constructor(
    private unsplashService: UnsplashService,
    private chainService: ChainService
  ) {
  }

  ngOnInit(): void {
    this.unsplashService.randomPhoto(true).subscribe(value => {
      this.backgroundImage = value;
    });

    setTimeout(() => {
      this.delayed = true;
    }, 50);

    if (!this.typeCategorySection.isExample) {
      this.chainService.getAllByTypeCategorySection(this.typeCategorySection).subscribe(chains => {
        this.chains = chains;
      });
    }
  }

  searchClicked() {
    this.onSearchClicked.emit(true);
  }
}
